<template>
  <div class="card-container">
    <a-tabs type="card">
      <a-tab-pane key="1" :tab="$t('moduleTitles.basicSetting')">
        <a-form>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">
              {{ $t("form.site.field.siteName.label") }}</span
            >
            <a-input
              v-decorator="['sitename']"
              v-model="siteSetting.sitename"
              :placeholder="$t('form.site.field.siteName.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.siteKeyword.label")
            }}</span>
            <a-input
              v-decorator="['keywords']"
              v-model="siteSetting.keywords"
              :placeholder="$t('form.site.field.siteKeyword.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("form.site.field.siteDesc.label") }}</span>
            <a-input
              type="textarea"
              :max-length="255"
              v-model="siteSetting.description"
              v-decorator="['description']"
              :placeholder="$t('form.site.field.siteDesc.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("form.site.field.siteLogo.label") }}</span>
            <div style="height: 100%">
              <div
                style="margin-bottom: 5px;width: 160px;background:#333;"
                v-if="siteSetting.logo"
              >
                <img
                  :src="siteSetting.logo"
                  width="100%"
                  height="100%"
                  alt="logo"
                />
              </div>
              <DragUploader
                ref="uploader"
                uptype="logo"
                :callback="getUploader"
                style="display:inline-block"
              >
                <a-button type="primary" slot="body">{{
                  $t("message.uploadBtn")
                }}</a-button>
              </DragUploader>
            </div>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("form.site.field.waterLogo.label") }}</span>
            <div style="height: 100%">
              <div
                style="margin-bottom: 5px;width: 160px;background:#333;"
                v-show="siteSetting.waterlogo"
              >
                <img
                  :src="siteSetting.waterlogo"
                  width="100%"
                  height="100%"
                />
              </div>
              <DragUploader
                ref="wateruploader"
                uptype="logo"
                :callback="watergetUploader"
                style="display:inline-block;margin-right:10px;"
              >
                <a-button type="primary" slot="body">{{
                  $t("message.uploadBtn")
                }}</a-button>
              </DragUploader>
              <span>{{$t("message.picture")}}</span>
            </div>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.enterpriseQrCode.label")
            }}</span>
            <div style="height: 100%">
              <div
                style="margin-bottom: 5px; height: 80px; width: 80px"
                v-if="siteSetting.enterprise_qrCode"
              >
                <img
                  :src="siteSetting.enterprise_qrCode"
                  width="100%"
                  height="100%"
                  alt="logo"
                />
              </div>
              <DragUploader
                ref="qrCodeUploader"
                uptype="logo"
                :callback="qrCodeUploader"
                style="display:inline-block"
              >
                <a-button type="primary" slot="body">{{
                  $t("message.uploadBtn")
                }}</a-button>
              </DragUploader>
            </div>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.ICPRecord.label")
            }}</span>
            <a-input
              v-decorator="['icp']"
              v-model="siteSetting.icp"
              :placeholder="$t('form.site.field.ICPRecord.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.companyAddress.label")
            }}</span>
            <a-input
              v-decorator="['address']"
              v-model="siteSetting.address"
              :placeholder="$t('form.site.field.companyAddress.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("form.site.field.mobile.label") }}</span>
            <a-input
              v-decorator="['phone']"
              v-model="siteSetting.phone"
              :placeholder="$t('form.site.field.mobile.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("form.site.field.qq.label") }}</span>
            <a-input
              v-decorator="['qq']"
              v-model="siteSetting.qq"
              :placeholder="$t('form.site.field.qq.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("form.site.field.email.label") }}</span>
            <a-input
              v-decorator="['email']"
              v-model="siteSetting.email"
              :placeholder="$t('form.site.field.email.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.closeRegistration.label")
            }}</span>
            <a-radio-group
              v-model="siteSetting.close_reg"
              v-decorator="['close_reg']"
            >
              <a-radio value="0">{{ $t("actionTitles.no") }}</a-radio>
              <a-radio value="1">{{ $t("actionTitles.yes") }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("moduleTitles.materialAduit") }}</span>
            <a-radio-group
              v-model="siteSetting.audit_type"
              v-decorator="['audit_type']"
            >
              <a-radio value="0">{{ $t("message.automaticAudit") }}</a-radio>
              <a-radio value="1">{{ $t("message.manualAudit") }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("message.openMultiCut") }}</span>
            <a-radio-group
              v-model="siteSetting.multi_pano"
              v-decorator="['multi_pano']"
            >
              <a-radio value="0">{{ $t("actionTitles.no") }}</a-radio>
              <a-radio value="1">{{ $t("actionTitles.yes") }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("message.temporaryCloseSite") }}</span>
            <a-radio-group
              v-model="siteSetting.close_site"
              v-decorator="['close_site']"
            >
              <a-radio value="0">{{ $t("actionTitles.no") }}</a-radio>
              <a-radio value="1">{{ $t("actionTitles.yes") }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{ $t("message.memberRenew") }}</span>
            <a-radio-group
              v-model="siteSetting.member_renew"
              v-decorator="['close_site']"
            >
              <a-radio value="0">{{ $t("message.unallowed") }}</a-radio>
              <a-radio value="1">{{ $t("message.allow") }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.closeSiteReason.label")
            }}</span>
            <a-input
              type="textarea"
              :max-length="255"
              v-decorator="['close_reason']"
              v-model="siteSetting.close_reason"
              :placeholder="$t('form.site.field.closeSiteReason.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.sliceProcess.label")
            }}</span>
            <a-input-number :min="0" v-model="siteSetting.slice_process" :placeholder="$t('form.site.field.sliceProcess.placeholder')"/>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
              $t("form.site.field.panoUrl.label")
            }}</span>
            <a-input v-model="siteSetting.index_pano_url" :placeholder="$t('form.site.field.panoUrl.placeholder')"/>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
            <a-button type="primary" @click="saveBase" html-type="submit">{{
              $t("message.saveSettingBtn")
            }}</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('message.saveSettings')">
        <a-row type="flex">
          <a-col :span="3" :order="2">
            <a-radio-group name="storage" v-model="siteSetting.storage">
              <a-radio
                style="display: block; height: 250px; line-height: 250px"
                value="qiniu"
                >{{ $t("message.qiniuCloud") }}</a-radio
              >
              <a-radio
                style="display: block; height: 300px; line-height: 300px"
                value="oss"
                >{{ $t("message.alicloud") }}</a-radio
              >
              <a-radio
                style="display: block; height: 100px; line-height: 100px"
                value="local"
                >{{ $t("message.localStorage") }}</a-radio
              >
              <a-radio
                  style="display: block; height: 300px; line-height: 300px"
                  value="aws"
              >{{ $t("message.awscloud") }}</a-radio
              >
            </a-radio-group>
          </a-col>
          <a-col :span="12" :order="3">
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.store") }}</span>
                <a-radio-group
                  name="qiniu"
                  v-model="siteSetting.qiniu.zone"
                  :options="qiniuzone"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">bucket</span>
                <a-input
                  v-model="siteSetting.qiniu.bucket"
                  :placeholder="$t('form.site.field.bucket.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessKey</span>
                <a-input
                  v-model="siteSetting.qiniu.accessKey"
                  :placeholder="$t('form.site.field.accessKey.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">secretKey</span>
                <a-input
                  v-model="siteSetting.qiniu.secretKey"
                  :placeholder="$t('form.site.field.secretKey.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.cdnDomain.label")
                }}</span>
                <a-input
                  v-model="siteSetting.qiniu.cdn_host"
                  :placeholder="$t('form.site.field.cdnDomain.placeholder')"
                />
              </a-form-item>
            </a-form>
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.store") }}</span>
                <a-radio-group
                  v-model="siteSetting.oss.zone"
                  :options="osszone"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.isIntranet") }}</span>
                <a-radio-group
                  v-model="siteSetting.oss.internal"
                  :options="enumstate"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">bucket</span>
                <a-input
                  v-model="siteSetting.oss.bucket"
                  :placeholder="$t('form.site.field.bucket.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessId</span>
                <a-input
                  v-model="siteSetting.oss.accessId"
                  :placeholder="$t('form.site.field.accessId.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessSecret</span>
                <a-input
                  v-model="siteSetting.oss.accessSecret"
                  :placeholder="$t('form.site.field.accessSecret.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.cdnDomain.label")
                }}</span>
                <a-input
                  v-model="siteSetting.oss.cdn_host"
                  :placeholder="$t('form.site.field.cdnDomain.placeholder')"
                />
              </a-form-item>
            </a-form>
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.storagePath.label")
                }}</span>
                <a-input
                  :placeholder="$t('form.site.field.storagePath.placeholder')"
                  v-model="siteSetting.local.bucket"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.visitDomain.label")
                }}</span>
                <a-input
                  :placeholder="$t('form.site.field.visitDomain.placeholder')"
                  v-model="siteSetting.local.cdn_host"
                />
              </a-form-item>
            </a-form>
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.store") }}</span>
                <a-radio-group
                    name="aws"
                    v-model="siteSetting.aws.zone"
                    :options="awszone"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">bucket</span>
                <a-input
                    v-model="siteSetting.aws.bucket"
                    :placeholder="$t('form.site.field.bucket.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessKeyId</span>
                <a-input
                    v-model="siteSetting.aws.accessKeyId"
                    :placeholder="$t('form.site.field.accessKeyId.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessKeySecret</span>
                <a-input
                    v-model="siteSetting.aws.accessKeySecret"
                    :placeholder="$t('form.site.field.accessKeySecret.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                    $t("form.site.field.cdnDomain.label")
                  }}</span>
                <a-input
                    v-model="siteSetting.aws.cdn_host"
                    :placeholder="$t('form.site.field.cdnDomain.placeholder')"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
                <a-button type="primary" @click="saveBase" html-type="submit">{{
                    $t("message.saveSettingBtn")
                  }}</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </a-tab-pane>
      <!-- 阿里雲通信 -->
      <a-tab-pane key="3" :tab="$t('message.alicloudCommunication')">
        <a-row type="flex">
          <a-col :span="3" :order="2">
            <a-radio-group name="sms" v-model="siteSetting.sms">
              <a-radio
                style="display: block; height: 200px; line-height: 200px"
                value="aliyuntongxun"
                >{{ $t("message.alicloudCommunication") }}</a-radio
              >
            </a-radio-group>
          </a-col>
          <a-col :span="12" :order="3">
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessId</span>
                <a-input
                  v-model="siteSetting.aliyuntongxun.accessId"
                  :placeholder="$t('form.site.field.accessId.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">accessSecret</span>
                <a-input
                  v-model="siteSetting.aliyuntongxun.accessSecret"
                  :placeholder="$t('form.site.field.accessSecret.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.smsSignature.label")
                }}</span>
                <a-input
                  v-model="siteSetting.aliyuntongxun.freesignname"
                  :placeholder="$t('form.site.field.smsSignature.placeholder')"
                />
              </a-form-item>
              <a-form-item
                v-bind="formItemLayout"
                :extra="$t('form.site.field.templateId.extra')"
              >
                <span slot="label">{{
                  $t("form.site.field.templateId.label")
                }}</span>
                <a-input
                  v-model="siteSetting.aliyuntongxun.templateId"
                  :placeholder="$t('form.site.field.templateId.placeholder')"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
                <a-button type="primary" @click="saveBase" html-type="submit">{{
                  $t("message.saveSettingBtn")
                }}</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </a-tab-pane>
      <!-- 三竹簡訊 -->
      <a-tab-pane key="8" :tab="$t('message.Newsletter')">
        <a-row type="flex">
          <a-col :span="3" :order="2">
            <a-radio-group name="sms" v-model="siteSetting.sms">
              <a-radio
                style="display: block; height: 200px; line-height: 100px"
                value="aliyuntongxun"
                >{{ $t("message.Newsletter") }}</a-radio
              >
            </a-radio-group>
          </a-col>
          <a-col :span="12" :order="3">
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">userName</span>
                <a-input
                  v-model="siteSetting.mitake.username"
                  placeholder="請輸入userName"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">passWord</span>
                <a-input
                  v-model="siteSetting.mitake.password"
                  placeholder="請輸入passWord"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
                <a-button type="primary" @click="saveBase" html-type="submit">{{
                  $t("message.saveSettingBtn")
                }}</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </a-tab-pane>
      <!-- 微信設置 -->
      <a-tab-pane key="4" :tab="$t('message.wechatSettings')">
        <a-row type="flex">
          <a-col :span="3" :order="2">
            <a-radio-group>
              <div style="height: 150px; line-height: 150px">
                {{ $t("message.wechatPublicPlatform") }}
              </div>
              <div style="height: 150px; line-height: 150px">
                {{ $t("message.WechatOpenPlatform") }}
              </div>
            </a-radio-group>
          </a-col>
          <a-col :span="12" :order="3">
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.isEnable") }}</span>
                <a-radio-group
                  v-model="siteSetting.wx.enabled"
                  :options="enumstate"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">appid</span>
                <a-input
                  v-model="siteSetting.wx.appid"
                  :placeholder="$t('form.site.field.appid.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">appsecret</span>
                <a-input
                  v-model="siteSetting.wx.appsecret"
                  :placeholder="$t('form.site.field.appsecret.placeholder')"
                />
              </a-form-item>
            </a-form>
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.isEnable") }}</span>
                <a-radio-group
                  v-model="siteSetting.wxweb.enabled"
                  :options="enumstate"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">appid</span>
                <a-input
                  v-model="siteSetting.wxweb.appid"
                  :placeholder="$t('form.site.field.appid.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">appsecret</span>
                <a-input
                  v-model="siteSetting.wxweb.appsecret"
                  :placeholder="$t('form.site.field.appsecret.placeholder')"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
                <a-button type="primary" @click="saveBase" html-type="submit">{{
                  $t("message.saveSettingBtn")
                }}</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="5" :tab="$t('message.paySettings')">
        <a-row type="flex">
          <a-col :span="3" :order="2">
            <a-radio-group>
              <div style="height:220px;line-height:220px;">{{$t('message.alipay')}}</div>
              <div style="height:200px;line-height:200px;">{{$t('message.wechatMerchants')}}</div>
              <div style="height:200px;line-height:200px;">{{$t('message.ecpay')}}</div>
            </a-radio-group>
          </a-col>
          <a-col :span="12" :order="3">
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.isEnable") }}</span>
                <a-radio-group
                  v-model="siteSetting.alipay.enabled"
                  :options="enumstate"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">appid</span>
                <a-input
                  v-model="siteSetting.alipay.appid"
                  :placeholder="$t('form.site.field.appid.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.merchantPrivateKey.label")
                }}</span>
                <a-input
                  type="textarea"
                  v-model="siteSetting.alipay.merchant_private_key"
                  :placeholder="
                    $t('form.site.field.merchantPrivateKey.placeholder')
                  "
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.alipayPublicKey.label")
                }}</span>
                <a-input
                  type="textarea"
                  v-model="siteSetting.alipay.alipay_public_key"
                  :placeholder="
                    $t('form.site.field.alipayPublicKey.placeholder')
                  "
                />
              </a-form-item>
            </a-form>
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{ $t("message.isEnable") }}</span>
                <a-radio-group
                  v-model="siteSetting.wxpay.enabled"
                  :options="enumstate"
                ></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">appid</span>
                <a-input
                  v-model="siteSetting.wxpay.appid"
                  :placeholder="$t('form.site.field.appid.placeholder')"
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.merchantNumber.label")
                }}</span>
                <a-input
                  v-model="siteSetting.wxpay.mchid"
                  :placeholder="
                    $t('form.site.field.merchantNumber.placeholder')
                  "
                />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{
                  $t("form.site.field.merchantPaymentKey.label")
                }}</span>
                <a-input
                  v-model="siteSetting.wxpay.key"
                  :placeholder="
                    $t('form.site.field.merchantPaymentKey.placeholder')
                  "
                />
              </a-form-item>
            </a-form>
            <a-form class="ant-form-bg">
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{$t('message.isEnable')}}</span>
                <a-radio-group v-model="siteSetting.ecpay.enabled" :options="enumstate"></a-radio-group>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{$t('form.site.field.hashKey.label')}}</span>
                <a-input v-model="siteSetting.ecpay.hashkey" :placeholder="$t('form.site.field.hashKey.placeholder')"/>
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{$t('form.site.field.hashIV.label')}}</span>
                <a-input v-model="siteSetting.ecpay.hashiv" :placeholder="$t('form.site.field.hashIV.placeholder')" />
              </a-form-item>
              <a-form-item v-bind="formItemLayout">
                <span slot="label">{{$t('form.site.field.merchantId.label')}}</span>
                <a-input v-model="siteSetting.ecpay.merchantId" :placeholder="$t('form.site.field.merchantId.placeholder')" />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
                <a-button type="primary" @click="saveBase" html-type="submit">{{
                  $t("message.saveSettingBtn")
                }}</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="6" :tab="$t('message.appSettings')">
        <a-form>
          <a-form-item v-bind="formItemLayout">
            <span slot="label"> {{
                  $t("form.site.field.android.label")
                }}</span>
            <a-input
              v-model="siteSetting.android_version"
              :placeholder="$t('form.site.field.android.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
                  $t("form.site.field.android.apk")
                }}</span>
            <div style="height: 100%">
              <DragUploader
                ref="uploader"
                uptype="apk"
                @updateImagefiles="updateImageList"
                @updateFileProgress="updateFileProgress"
                @startUploadImage="isUploading = true"
              >
                <a-button type="primary" slot="body">{{
                  $t("message.uploadBtn")
                }}</a-button>
              </DragUploader>
            </div>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label"> {{
                  $t("form.site.field.android.url")
                }}</span>
            <a-input
              v-model="siteSetting.android_download"
              :placeholder="$t('form.site.field.android.aplaceholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label"> {{
                  $t("form.site.field.ios.label")
                }}</span>
            <a-input
              v-model="siteSetting.ios_version"
              :placeholder="$t('form.site.field.ios.placeholder')"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">{{
                  $t("form.site.field.ios.url")
                }}</span>
            <a-input
              v-model="siteSetting.ios_download"
              :placeholder="$t('form.site.field.ios.aplaceholder')"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
            <a-button type="primary" @click="saveBase" html-type="submit">{{
              $t("message.saveSettingBtn")
            }}</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
      <!-- line -->
      <a-tab-pane key="7" :tab="$t('message.lineSettings')">
        <a-form>
          <a-form-item v-bind="formItemLayout">
              <span slot="label">clientId</span>
              <a-input
                v-model="siteSetting.line.clientid"
                :placeholder="$t('form.site.field.clientId.placeholder')"
              />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
              <span slot="label">clientSecret</span>
              <a-input
                v-model="siteSetting.line.clientsecret"
                :placeholder="$t('form.site.field.clientSecret.placeholder')"
              />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
              <span slot="label">redirect_uri</span>
              <a-input
                v-model="siteSetting.line.redirect_uri"
                :placeholder="$t('form.site.field.redirect_uri.placeholder')"
              />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 10, offset: 3 }">
            <a-button type="primary" @click="saveBase" html-type="submit">{{
              $t("message.saveSettingBtn")
            }}</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :visible="isUploading"
      :width="150"
      :footer="null"
      :closable="false"
      :destroyOnClose="true"
    >
      <div style="margin: 0 auto; width: 80px;height: 90px;">
        <Progress :percent="parseInt(loadingPercent)" message="上傳中"></Progress>
      </div>
    </a-modal>
  </div>
</template>
<script>
import api from "../../../../api/index";
import request from "@/utils/request";
import DragUploader from "@/components/DragUploader";
import Progress from "@/components/progress";
import { mapGetters } from "vuex";
import { getSiteConfig } from "@/api/index";

export default {
  components: {
    DragUploader,
    Progress
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
      },
      siteSetting: {
        //沒有數據，要保證數據結構
        qiniu: {},
        oss: {},
        local: {},
        sms: {},
        alipay: {},
        wxpay: {},
        wx: {},
        line:{},
        wxweb: {},
        aliyuntongxun: {},
        enterprise_qrCode:"",
        ecpay:{},
        mitake:{},
        aws:{},
      },
      qiniuzone: [],
      osszone: [],
      awszone:[],
      enumstate: [
        { label: this.$t("actionTitles.yes"), value: "1" },
        { label: this.$t("actionTitles.no"), value: "0" },
      ],
      isUploading: false,
      loadingPercent: 0,
    };
  },
  computed: { ...mapGetters(["siteInfo"]) },
  created() {
    // this.siteSetting = this.$deepClone(this.siteInfo);
  },
  methods: {
    saveBase() {
      // console.log("baocun====>",this.siteSetting)
      this.$store.dispatch("saveSiteConfigInfo", this.siteSetting);
    },
     updateImageList(fileList) {
      this.isUploading = false;
      console.log(fileList);
      this.siteSetting.android_download = fileList[0].url
    },
    updateFileProgress(progress) {
      this.loadingPercent = progress;
    },
    //回調方法，up為上傳實例對像
    getUploader: function (up) {
      let _this = this;
      _this.$nextTick(() => {
        up.bind("UploadComplete", function (up, file) {
          _this.siteSetting.logo = _this.$refs.uploader.fileList[0].url;
        });
      });
    },
    qrCodeUploader(up) {
      let _this = this;
      _this.$nextTick(() => {
        console.log("成功");
        up.bind("UploadComplete", function (up, file) {
          _this.siteSetting.enterprise_qrCode =
            _this.$refs.qrCodeUploader.fileList[0].url;
        });
      });
    },
    watergetUploader(up){
      let _this = this;
      _this.$nextTick(() => {
        up.bind("UploadComplete", function (up, file) {
          _this.siteSetting.waterlogo = _this.$refs.wateruploader.fileList[0].url;
        });
      });
    },
  },
  mounted() {
    getSiteConfig().then((res) => {
      if (res.code === 1) {
        this.siteSetting = res.data;
      }
    });

    //獲取存儲區域
    request({ url: api.StorageZone, method: "post" /*data: {},*/ })
      .then((res) => {
        let qiniu = res.data.qiniu;
        for (var key in qiniu) {
          this.qiniuzone.push({ label: qiniu[key].name, value: key });
        }
        let oss = res.data.oss;
        for (var key in oss) {
          this.osszone.push({ label: oss[key].name, value: key });
        }
        let aws = res.data.aws;
        for (var key in aws) {
          this.awszone.push({ label: aws[key].name, value: key });
        }
        console.log("獲取存儲區域===>",this.osszone);
        console.log("獲取存儲區域===>",this.awszone);
      })
      .catch((err) => {
        console.log("==err=", err);
      });
      console.log("this.siteSetting",this.siteSetting)
  },
};
</script>
<style>
.ant-form-bg .ant-form-item-label {
  width: 20%;
}
.ant-form-bg .ant-form-item-control-wrapper {
  width: 80%;
}
span.ant-radio + * {
  padding-left: 4px;
}
.ant-form-item {
  margin-bottom: 10px;
}
.ant-tabs {
  padding-bottom: 20px;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  margin-top: -16px;
}
.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}
.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}
</style>
